import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './error/error.component';
import { ApiConnectionComponent } from './json-users/api-connection.component';
import { HttpService } from './services/json.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiConnectionDetailComponent } from './json-users-todo-detail/api-connection-detail.component';
import { TodosComponent } from './json-todos/todos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from './contact/contact.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaginatorPipe } from './pipes/paginator.pipe';
import { GithubReposComponent } from './github-repos/github-repos.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ErrorComponent,
    ApiConnectionComponent,
    ApiConnectionDetailComponent,
    TodosComponent,
    ContactComponent,
    PaginatorPipe,
    GithubReposComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
  ],
  providers: [ HttpService ],
  bootstrap: [AppComponent]
})
export class AppModule { }
